import jsPDF from "jspdf";
import "jspdf-autotable";
import { getLoggedUser } from "../../context/auth";
import moment from "moment";
import CommonUtilities from "../Utilities/Common";
let loggedUser = {};
const GlobalConfig = new window.globalConfig();
const lodash = require("lodash");

export const handleExportDetailedPdf = async (e) => {
  window.showAlert("Info", "Exporting...", "info");

  try {
    loggedUser = getLoggedUser();
    const action = e.currentTarget.dataset.action;
    const dataRequest = {
      paymentId: e.currentTarget.dataset.paymentid,
      cropYearId: e.currentTarget.dataset.cropyearid,
      growerId: e.currentTarget.dataset.growerid,
      varietyId: e.currentTarget.dataset.varietyid,
      createdUserId: loggedUser._id,
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dataRequest),
    };

    fetch(
      GlobalConfig.REACT_APP_API_GROWER_STATEMENT_DETAILED_URL + "exportpdf",
      requestOptions
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (resultObject) {
        if (resultObject && resultObject.result === "OK") {
          window.closeAllAlerts();
          composePdfFile(
            resultObject.data,
            action === "print",
            action === "preview"
          );
        }
        //If failed, show error
        else {
          window.showAlert("Error", resultObject.message, "error");
        }
      })
      .catch(function (error) {
        window.showAlert("Error", error, "error");
      });
  } catch (err) {
    window.showAlert("Error", err.message, "error");
  }
};

function composeFooter(doc, currentDate, processorName, growerName) {
  const pages = doc.internal.getNumberOfPages();
  if (pages) {
    const pageWidth = doc.internal.pageSize.width; //Optional
    const pageHeight = doc.internal.pageSize.height; //Optional
    doc.setFontSize(10); //Optional

    for (let j = 1; j < pages + 1; j++) {
      let horizontalPos = pageWidth / 2; //Can be fixed number
      let verticalPos = pageHeight - 10; //Can be fixed number
      doc.setPage(j);
      doc.text(
        `${processorName} Grower Statement for ${growerName}`,
        10,
        verticalPos
      );
      doc.text("Page " + j + " of " + pages, horizontalPos, verticalPos, {
        align: "center",
      });

      doc.text(`${currentDate}`, pageWidth - 10, verticalPos, {
        align: "right",
      });
    }
  }
}

export const composePdfFile = (data, isPrint, isPreview) => {
  if (data && data.length > 0) {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
    const doc = new jsPDF(orientation, unit, size);

    const currentDate = moment().format("dddd, MMMM DD, YYYY");

    let index = 1;
    let startY = 90;
    data.map((u) => {
      //Insert header
      composeHeader(u.growerInfo, doc);
      //Insert tables

      //unique fields
      const fields = lodash(u.items)
        .filter("fieldName")
        .groupBy((x) => {
          return [x["fieldName"]];
        })
        .map((children, fieldName) => {
          const items = children.map((x) => x);
          return {
            fieldName,
            items,
          };
        })
        .value();

      const tableFontSize = 6;
      composePaymentTable(u, fields, doc, tableFontSize, startY);

      composeFooter(doc, currentDate, u.processorName, u.growerInfo.growerName);

      if (index++ < data.length) {
        doc.addPage();
      }
    });
    //open popup print
    if (isPrint || isPreview) {
      const fileName = `detailed-grower-statement-${data[0].growerInfo.growerName
        .replace(" ", "_")
        .replace("%20", "_")
        .toLowerCase()}.pdf`;
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        window.navigator.msSaveOrOpenBlob(doc.output("blob"), fileName);
      } else {
        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        if (isPrint) {
          doc.autoPrint();
        }
        window.open(
          URL.createObjectURL(doc.output("blob")),
          "_blank",
          "height=" +
            window.innerHeight +
            ",width=" +
            window.innerWidth +
            ",scrollbars=yes,location=yes"
        );

        // For Firefox it is necessary to delay revoking the ObjectURL
        setTimeout(() => {
          window.URL.revokeObjectURL(doc.output("bloburl"));
        }, 100);
      }
    } else {
      //export file(s)
      const fileName = `detailed-grower-statements.pdf`;
      doc.save(fileName);
    }
  } else {
    window.showAlert("Infor", "No data export!");
  }
};

function composeHeader(growerInfo, doc) {
  doc.setFontSize(8);
  const growerName = growerInfo.growerName
    ? growerInfo.growerName.toUpperCase()
    : ``;
  // const growerAddress = growerInfo.growerAddress
  //   ? growerInfo.growerAddress.toUpperCase()
  //   : ``;

  const businessName = growerInfo.businessName
    ? growerInfo.businessName.toUpperCase()
    : ``;
  const businessAddress = growerInfo.businessAddress
    ? growerInfo.businessAddress.toUpperCase()
    : ``;
  // const phoneNumber = growerInfo.phoneNumber
  //   ? growerInfo.phoneNumber.toUpperCase()
  //   : ``;
  doc.text(businessName, 160, 30);
  doc.text(businessAddress, 160, 45);
  // doc.text(phoneNumber, 160, 60);

  // doc.text(growerAddress, 160, 45);

  doc.setFontSize(14);
  const title = `Grower Statement - CROP YEAR ${growerInfo.cropYear.toUpperCase()}`;
  doc.text(title, 500, 30);
  doc.setFontSize(8);
  doc.text(growerName, 500, 45);

  if (growerInfo.processorImage && growerInfo.processorImage !== "") {
    let format = growerInfo.processorImage
      .split(";base64,")[0]
      .split("data:image/")[1];
    if (growerInfo.isRectangleLogo) {
      doc.addImage(growerInfo.processorImage, format, 2, 2, 150, 75);
    } else {
      doc.addImage(growerInfo.processorImage, format, 2, 2, 75, 75);
    }
  } else {
    //Parity Factory logo, printed at top left
    doc.addImage(
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAbIAAACSCAMAAAAXdr+sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjRENTM0NEEyOEM2MTExRTlBNDU4RDU1M0I5OTJBNTVBIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjRENTM0NEEzOEM2MTExRTlBNDU4RDU1M0I5OTJBNTVBIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NEQ1MzQ0QTA4QzYxMTFFOUE0NThENTUzQjk5MkE1NUEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NEQ1MzQ0QTE4QzYxMTFFOUE0NThENTUzQjk5MkE1NUEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5/MCzRAAABFFBMVEX///8dNWX7r0MdNWX7r0MdNWX7r0OKamFWTGQdNWX7r0NMSGTQlFMdNWX7r0NpV2MdNWX7r0N/Y2IdNWUdNWWSb2D7r0NYTmTMklQdNWX7r0OWcWA4P2XqpUvcnFAdNWVOSWXbm1D7r0OObGGleV6bdF8dNWXGjlb7r0NvWmPXmVEdNWX7r0NXTWTQlFMdNWX7r0OBZWEdNWVAQ2UdNWXkoU37r0MdNWWKamFrWGPdnU94X2Pbm1G0glvFjlcdNWX7r0MdNWUuO2X5rkTQlFNLSGWObGGtfVzMklTdnU9LSGXKkFWpe10dNWV9YmIdNWWKamHno0z7r0NiU2T1q0ZuWmP0q0Z6YGIdNWU5QGVTS2T7r0OicaLYAAAAWHRSTlMAEBAgIDAwPD1AQExMUFBYYGBkanBwcHR0gICHiIiPkJCQkJKSnKCgoKGlsLCyvsDAxMjL0NDQ09PU1tjZ3N3g4OLi4uTm6Ojo6Onr7e7u8PDw8PX19vb3UpZObgAAEHRJREFUeNrtnQuX6zYRgP1YBxzIohSzoPAwXYpvwBcUwF3eeMurQKGmoYBL/v//wJIlW3L0SiJnNz2ac9q7m921bH2a0cxoJAeBFy9evHjx4sWLFy9evHjx4sWLFy9evHjx4sWLFy9evHjxcvvyzo98H9yYLP/zdd8JN4bs8FHie+HGkB1+7Xvh1pB9kvluuCW522y+42ezz7UkqUJiu78P07NbSEPdZZkMM3OcWkk8bdPmxm5q+ketSpoyC81/X7Tg7BZwE4qRkQ6/g9hHsLUSiH8XcB+sVMSmf/RS8u6hkw+BA2RYCpOuxW1bX9RCWyQzIAuq8YM6NN5XHb4ksg1Gdvi9I2Rtm4cGJWtNamZqQdrEpchSowrxipi+qKHbEmQfQ1fI2irRK5lRzYwttHXiHBkZS0xkpiJsxp+XLzs37QiyT5rQFbK2SfRKZlIzcwuSJi5GZkKSc63HL4vsh+9j+dXPVs6QaZjFVEsubeG4iYuRBZnW8MWvxfdw6jFaDMOS/gK4tIW2co5M8EB0N1XNEDixDktfCpnqqVJ1l5zawnSoO0Cm80BWs/keEGGLnNPvuq7LV/Mhg7ygRuiHzPC3wKqFQmgiRxpNliBLhb/mAIqfpxbTVVhz/uoc/Vnzmg5nQzYdiBXfoaE2dtIGNkg5nsO8VXWdBNlEWtWNS53CQlQFw5NdIDR2SLhnN6jxtw9U/mxpo5H6yaFBzZDdFI40JogLjhrnyJShF+97ADekksF/qvn+GpBp8n9bhuyPA+mzkfGPXGuVTDtYdcj4YbFyjkzlZHAfIyfAOnMxXD/jr1uwx4bqRNKOIfvr1BicgWzwCFsZf6RzH2yRBbXcMrpBFkvtxMoQZZ9OrOJun5rjcByRad8JqoB9z5AdpqbmHGSxBkk6CQTC85BlcjZukMknrdpxSJY0gpXIOYM7IKvVbb158+bHJJj+DUIouRQZl/YpTb47PA9ZIu96R8j44Kw4xli7IBY34piIudYgUzg2pblwdvTIVhaxrknN9MiCeZHxKyyJ0MPOQrJqeqfF6E2l9P5SeptVFc6NLFR2DDIFw7bI6lmR8cEZms7PbtLBYDpdpuMAYchAP+ZjSwfjEmTKjllJ0lrhWcjQvMj4qBmIN+4qJEubiY+GBm+KIYP997nEFi+Z3M2MrDbnnCyRNfMi4y14x4gn6KyqKWnEjAIYZpKY3h/qx0t9HAdGh1H+Zze96pHFio7hIrbSNGr1yMJ2ZmS8Jcx53wMFgXNmBTegY3qXdf9BTCbWYyWbILOIpm3dD6RQMsSlhfIzkAG5++YQGZ+3Aq0u0nTAjPPtAb1LRP5per+k+zAVPLnNFFl2ITKFkw94p6swBKa2oTSaCZmwcuY0HRwdM+vzz2SUlNTsI/I0Jfmm1zieytspsvIyZNwAzZT9HKuSrycmrLK5kEmXfxxU6KwPG45ZzQdDBbsvRB5gRSb6FVGyTFxWWG8Gefdb3QoKyi9DpkhYAdEJM6iZZVpYNFROkSUSZJevYi26TNPTQsxaMe2NWRM9MkievcRK1mnBpZloHbJCkSeoxY8NaqZGFiPlMqpTZHxw5iwki56JMdscMUvZYM+H3GKJbzIkhqTA3wMwD7JYtbgCpksXpVbNxstkfFXvarKMCmZEFja2pRH2wtZMRkWjzIjjnNLxnJOuq/CABPgnKbbISVO6QSYu7sJKGSbXU91LtWpmV0hQBTMiEwywm3Tw/eg1bCbMSpbGSohJhPhec9wPBF6KBxCbBKIuJ/zNr1H5imWxuV2HZjolEy4Sn9lCMiuyyU04SAc/c57eoGiUWUZ7KaPIEtxTMR73ALOrRouyPkwdRot40apDkdzINJIMQ3FeCzCYF5nogThIBy+2fG8/RsL0n/S2CBFyELuKcecpwq7vKrqLARy7+Afp8vyZyASHGMr6udKomU0LRTAzMqF62EFqtpO77bg4eXhe8u3gfD0kyy4p7iWIMdSdkuVdvWaGiRXwKFuF6wjsnufU0lNeyUKZsSzOaKEIZkfG37er6uBosz9WtII+EG4Q4OdIO/es7NQcG8is+6AzjQXtUsEufmybljF3qLjEA+XGrFZbHXTSTDkXMs7Rd1gGF62fjxStoDFZgckRZFXXVXmncgh1zmIxEgu+wDyP9968u/kuc/ziC5E1UDlYQ7lPgk5sQbp47h4ZnKmge72bKlrRa3JMpiWMDP/XoQJNGFY8sYudfCmwaV0QVFkztZoZWkgNSyavHVmXjN9NFC3rb7vENq4uO88Dds8Th/UqQF0AUFRxEBbzIGtKEJpiUpN/GUirhQtjIfItIcOeiKhogLSS8vmBOIBFkHeTTFHhWDp3gmwSSkuLJe3q4lNjwqo0LYLcFrIO2uOeVzRAnjYXOiIOASWWNWScfvkNJz/oetxylzo65cmtlGzayzJk/IXq8NaQLfZvH5bH7uMzp2hA9lyd0crKMCxRfBSNHz6zT82chMxy84moZtK0cGpI0b5qZL1vvttMsVH3kSgakEZ/oAiSCkoyHx+28yCzVLJJN8sz+fm1nXyHyMaV5N3jfSRkHneDokndKhCAwUF+4oh9+tlMyIq2PUPN5MjCSjudvWpkQprp8PS45oqjlm+FZMjRXQyNf4O/xj/beZDF1sSEflaslyXKaP3VI9sdpvK8HbH17uO91ZXeoaH0l5jrAYQdchcjs1cygY5qiTO7ao7RJbLng0w6n2QxJrLugtnEHhmnZDWSSyNb3lCuSpeabV6vGtlBKXvqk0T3wWtAZqqkEj1KYEbGezNN8rlAxlzJKHgNyEyFVBMItRmZ4OlPprNXjWy5fOgKora73e5JhW1puML7o/yunCQxnIXSFkomVzNNhRWcda/01XKMy2OGemQRPxv+S588Oh+ZjZLJ1UxXFFe1s268vV7CasrQPkr495Hr5krLCrtLQl1hiOSQm0ZR9XTTyOyyJ5KI7NRVaQdKJlUzbbXwSlFkdavIImIjdzutmq03jzsa2/1dsoDiCFlpu/3gWM30NflQHvbfFrLF8p5MZVxZgU32f7n8HixRpV+7OpZ8CKq0SjbGXobFuXD8zXzaghR2wcV1o2lMplc5HmtWN86l94bfB24VShJYP2/vNX92HAGQrAcLa4vAi3PBCrVXufd87komnU/5vNus5ZazO1IZpr6D3YsyGhsyxNHD1rgK8NsSrvxbKK4kOzmuYR2GLFHLTeM6WjwSS/rpf6nPVcA09l06tzxqcLHll53UOm4P+3XnrTz+4aPPRJcjz9LQd+yMc5mYURRWOdfEanZgos3iaKaKMM3nNXav8uMDAhqUAz+RzZTd4BLAojdIy4e3URA9HfYTRUvqInjofvqXP5FEj4yay3MSvPBk5KUfbGcFXpJedBPWNrgT/HmAHfjFL7BJRL02yah5j2QW2W6OffT7HbfdbIk35QbR/rBmP37Yvxf89B8ffLWrOu1nL2oCp9Qa37tX0rsHFlATtwMnEZ8inP29S9qfB1/85U+C73/8N5JR7eL4VR8yl8xRFKiVvjOvIUPdKfEH+z25+whv9NziAwi67FvTH0eQ9Wm8mOaoxur5kZqfyq7hjIxLKVs8dxG3cL/AZrGrAKm6nGGK86Dk0A9EM62sJLAYPfs4q5yd6elFJ+unyW6lO/LBgiyKvcXHEBRsk1n3P2waSc0EO6qsgVw41lGrfI/OPIXxewL7Xe4L8sm6jwSW/cZbsp8CkBx9xupcQtRKoHmZV4Tt0jTbsWbEcK3ALuh1i+y+DXubiIbF3GE1qAG+L68i93ymcU+d+Yd+SqNJrXtyhlVCj7Cq+uOjmqE2KRkcxdpDu4II2fwtDZm3AzFsFp/ZAbXpYBMTWnHbMwvHheN65bt0bnk8Po0g6jF2ARkxi9g89sec9uASunyJuBpAMNZdIJ9enDsWOzpcZzESI0A7JaOHf6T9Md5178P3JUp07Tnhygg8tLmTVoLb0eeo8Kx2R83i4aEvcsp7ZGkfjGFSGV8voHnvjZc51Gw/5BBpodser7gQs9ilPwgc2CPLaDUZdhZLocZj1bh+AY0XhWxGt2Oc2pb0J729pMmOlJZ1NfRfWjnIKr1Y/srNmxa8aOLot0M6P2IRGlG6BfkyokddJz0yXAdWsNNSVhOlgl7Jrg2PefwPo/+PPX3AvYuiYt8T3SonjEj+6jQlA+I+MQ3ulSnVHGeI7EADoV1bqjLEOCf2oso1idKxRBJB5dIgKYkc77qwL320zYKwrNU2GMwi2RJYUA7sBQfhcCgRK6oeorEQnapk0PqEyVr/DgfOAWqgVVut6Tqat5EL58zk2pfOMPDAeb3wPSP2NhjNIqHXUIOYshtAw/LK6mhbXXZiRtgaGdA/r7BpvTtD/1xkiXAd5dvIkc1LXvtd2VSxwsb1NP8wlFlFXFpkwUjl7IuUufd966V8K+QMyGrtq1IYsaZWbVu3Q8bsRl3bvk5Ge9v5aINy1++43U6I9WZxN7QFGTL8RTzOYOwRz2YGLa0FsHghYJN1NiCEjb6+HOm6rr8OwKmCrNFsLRgvkujWB0fVSlyv1Q/7jvYLziz2vn41vIhzCJPrUc1WrWZYO0RWa99I1L+eJuZsWxWeg0y4Th+1ANNFCBaVa7RiIw05f8ftk0CMFhITJYuHgql0GHW55NzzM5lZIsv0BqgSOiSuC43S65DVwnUIjMp4kVz3CGW/SgXcV1dQB/9emNjWY2cFDFk9fEVtxrAV7zxmdsjCRju1JKd0iAZZMlGrTFnex19E+wgkFVuGjdsXKo3MaN7qrncen0ctqkZQAXMi2T2vLnrHE37eYnjrQKj5LeJZQLUOBpcjy6blfMqhwF+k0o46cm9oltLOjhlL5u84JQtHGtxrAwueUXlJbhHabIkngxQC5TwPTxkwGmRQdnAZNFwEGB69mi9ZHj2I/v6e0yE4IkuH22Q3zawWCOZCBnub2Kg8QXhKjxiQCdcpdMiK8RxVnWOROnuhklKoWaQ6V4xlielILxQKTAnW5rwFaRtkIU1EQ5WavYyW2e5AKBy9UEkt1Czuo+mslXKLLaVwqkM5esbnIEOG410YqlClZtkpJeWGuaydzmXAjKww+05oRmIPwip1wqHh/cRMuNfw/EOGLTzGkZRKzZJT7LLJY8xsPUbrKiU08/kRLNV4x9stzij3ozkWD085305bIIOtcUiL8VTcuInLYn1cht+wVdu8Y2JuZLT2Y8u7OxU/jwp+0MXnDpiRHR1SG7+i7EeiywpfCxmtO73jlQnxyNIxy+kgB2NGBs3vaeFzgy5yjJl9jhFa+O/zI8MF31tu1LH2Un5xLHH0ZkkjMmKdxFcTSNSMvWi7ro2pGC2y4TqN/jrjRZC5F66ADHv6QpSc8cho443sLR8zICvEZaZaoUGxxXqZBbLJdarQeBEypPTT2XWQcU7ucHOpEIwVbQUcRIcmZPEkGwxUThy/Kp2f6TFOrmNYlU65qBS9FmSs3D7mkdG7i91sIQOGo51IvQbfcyUut5DTJW/xrFGmH0m56kwr8TpdtBjbXQTiW1wZWrxeDVMMcsScxPSk89G8vAKJu+l/lfqjBrx48eLFixcvXrx48eLFixcvXrx48eLFixcvXrx48eLFixcvXrx48eLFixcvXj6v8n/Gp+fV9w6sGwAAAABJRU5ErkJggg==",
      "png",
      2,
      2,
      140,
      60
    );
  }
}

function composePaymentTable(data, fields, doc, tableFontSize, startY) {
  const allItems = data.items;
  const columns = [
    {
      header: "Delivery",
      dataKey: "lotNumber",
    },
    { header: "Variety", dataKey: "variety" },
    { header: "Date", dataKey: "testDate" },
    { header: "Delv. Weight", dataKey: "netWeight" },
    { header: "Edible\nYield", dataKey: "s3EdibleYield" },
    { header: "Payable\nWeight", dataKey: "payableWeight" },
    { header: "Internal\nDefect", dataKey: "internalDefect" },
    { header: "External\nDefect", dataKey: "externalDefect" },
    { header: "Jumbo/\nLarge", dataKey: "jumboLarge" },
    { header: "Moisture", dataKey: "moisture" },
    // { header: "Quality\nAdj", dataKey: "qualityAdj" },
  ];

  const columnsTotal = [
    {
      header: "Delivery",
      dataKey: "lotNumber",
    },
    { header: "Payable\nWeight", dataKey: "payableWeight" },
    { header: "Internal\nDefect", dataKey: "internalDefect" },
    { header: "External\nDefect", dataKey: "externalDefect" },
    { header: "Jumbo/\nLarge", dataKey: "jumboLarge" },
    { header: "Moisture", dataKey: "moisture" },
    // { header: "Quality\nAdj", dataKey: "qualityAdj" },
  ];

  for (let i = 0; i < data.summary.payments.length; i++) {
    const payment = data.summary.payments[i];
    let columnTitle = ``;
    if (payment.paymentNo === 1) {
      columnTitle = `1st`;
    } else if (payment.paymentNo === 2) {
      columnTitle = `2nd`;
    } else if (payment.paymentNo === 3) {
      columnTitle = `3rd`;
    } else {
      columnTitle = `${payment.paymentNo}th`;
    }
    columns.push({ header: "$/ mt lb", dataKey: `mtlb${payment.paymentNo}` });
    columns.push({
      header: `${columnTitle}\nPayment`,
      dataKey: `payment${payment.paymentNo}`,
    });

    columnsTotal.push({
      header: "$/ mt lb",
      dataKey: `mtlb${payment.paymentNo}`,
    });
    columnsTotal.push({
      header: `${columnTitle}\nPayment`,
      dataKey: `payment${payment.paymentNo}`,
    });
  }

  columns.push({ header: "Meat\nPrice", dataKey: "meatPrice" });
  columns.push({ header: "Inshell\nPrice", dataKey: "inshellPrice" });
  columns.push({ header: "Total", dataKey: "total" });

  columnsTotal.push({ header: "Meat\nPrice", dataKey: "meatPrice" });
  columnsTotal.push({ header: "Inshell\nPrice", dataKey: "inshellPrice" });
  columnsTotal.push({ header: "Total", dataKey: "total" });

  const numberColumnStyle = {
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 40,
  };
  const smallColumnStyle = {
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 35,
  };
  const bigColumnStyle = {
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 45,
  };

  //Print empty field
  let emptyItemsTable = allItems.filter((t) => {
    return (
      t.fieldName === undefined || t.fieldName === null || t.fieldName === ``
    );
  });
  //sort by variety
  emptyItemsTable.sort(CommonUtilities.getSortOrder("variety"));

  //unique varieties
  const emptyVarieties = lodash(emptyItemsTable)
    .filter("variety")
    .groupBy((x) => {
      return [x["variety"]];
    })
    .map((children, variety) => {
      const items = children.map((x) => x);
      return {
        variety,
        items,
      };
    })
    .value();
  let printField = true;
  let showHeaderColumn = true;
  emptyVarieties.map((v) => {
    const itemsByVariety = v.items.filter((k) => {
      return k.variety === v.variety;
    });
    if (printField) {
      doc.setFontSize(10);
      doc.text(`Field: `, 2, startY, {
        align: "left",
      });
      startY += 5;
    }

    printTableByField(
      doc,
      showHeaderColumn,
      data,
      itemsByVariety,
      startY,
      columns,
      tableFontSize,
      numberColumnStyle,
      smallColumnStyle,
      bigColumnStyle
    );
    //Add data for table total by variety
    if (itemsByVariety && itemsByVariety.length > 0) {
      const payableWeight = lodash.sumBy(itemsByVariety, "payableWeightOrigin");
      const qualityAdj = lodash.sumBy(itemsByVariety, "qualityAdjOrigin");
      const total = lodash.sumBy(itemsByVariety, "totalOrigin");
      const itemsByVarietyTotal = [];
      const obj = {
        lotNumber: `Totals for ${v.variety.toUpperCase()} (${
          itemsByVariety.length
        } ${itemsByVariety.length > 1 ? `deliveries` : `delivery`})`,
        payableWeight: CommonUtilities.numberWithCommas(
          (payableWeight == null ||
          payableWeight === undefined ||
          isNaN(payableWeight)
            ? 0
            : parseFloat(payableWeight)
          ).toFixed(0)
        ),
        qualityAdj:
          qualityAdj < 0
            ? `($${CommonUtilities.numberWithCommas(
                Math.abs(qualityAdj).toFixed(2)
              )})`
            : `$${CommonUtilities.numberWithCommas(qualityAdj.toFixed(2))}`,
        total:
          total < 0
            ? `($${CommonUtilities.numberWithCommas(
                Math.abs(total).toFixed(2)
              )})`
            : `$${CommonUtilities.numberWithCommas(total.toFixed(2))}`,
      };
      var convertedJSON = JSON.parse(JSON.stringify(obj));
      for (let i = 0; i < data.summary.payments.length; i++) {
        const p = data.summary.payments[i];
        const totalPayment = lodash.sumBy(
          itemsByVariety,
          `payment${p.paymentNo}Origin`
        );
        convertedJSON[`payment${p.paymentNo}`] =
          totalPayment < 0
            ? `($${CommonUtilities.numberWithCommas(
                Math.abs(totalPayment).toFixed(2)
              )})`
            : `$${CommonUtilities.numberWithCommas(totalPayment.toFixed(2))}`;
      }
      itemsByVarietyTotal.push(convertedJSON);
      startY = doc.previousAutoTable.finalY;
      printTableTotal(
        doc,
        data,
        itemsByVarietyTotal,
        startY,
        columnsTotal,
        tableFontSize,
        numberColumnStyle,
        smallColumnStyle,
        bigColumnStyle
      );
    }
    showHeaderColumn = false;
    printField = false;
    startY = doc.previousAutoTable.finalY;
  });
  if (emptyItemsTable && emptyItemsTable.length > 0) {
    //Add data for table total by variety empty
    const payableWeight = lodash.sumBy(emptyItemsTable, "payableWeightOrigin");
    const qualityAdj = lodash.sumBy(emptyItemsTable, "qualityAdjOrigin");
    const total = lodash.sumBy(emptyItemsTable, "totalOrigin");
    const itemsByVarietyTotal = [];

    const obj = {
      lotNumber: `Totals for (${emptyItemsTable.length} ${
        emptyItemsTable.length > 1 ? `deliveries` : `delivery`
      })`,
      payableWeight: CommonUtilities.numberWithCommas(
        (payableWeight == null ||
        payableWeight === undefined ||
        isNaN(payableWeight)
          ? 0
          : parseFloat(payableWeight)
        ).toFixed(0)
      ),
      qualityAdj:
        qualityAdj < 0
          ? `($${CommonUtilities.numberWithCommas(
              Math.abs(qualityAdj).toFixed(2)
            )})`
          : `$${CommonUtilities.numberWithCommas(qualityAdj.toFixed(2))}`,
      total:
        total < 0
          ? `($${CommonUtilities.numberWithCommas(Math.abs(total).toFixed(2))})`
          : `$${CommonUtilities.numberWithCommas(total.toFixed(2))}`,
    };
    var convertedJSON = JSON.parse(JSON.stringify(obj));

    for (let i = 0; i < data.summary.payments.length; i++) {
      const payment = data.summary.payments[i];
      const p = lodash.sumBy(
        emptyItemsTable,
        `payment${payment.paymentNo}Origin`
      );
      convertedJSON[`payment${payment.paymentNo}`] =
        p < 0
          ? `($${CommonUtilities.numberWithCommas(Math.abs(p).toFixed(2))})`
          : `$${CommonUtilities.numberWithCommas(p.toFixed(2))}`;
    }
    itemsByVarietyTotal.push(convertedJSON);
    startY = doc.previousAutoTable.finalY;
    printTableTotal(
      doc,
      data,
      itemsByVarietyTotal,
      startY,
      columnsTotal,
      tableFontSize,
      numberColumnStyle,
      smallColumnStyle,
      bigColumnStyle
    );
  }

  startY =
    doc.previousAutoTable.finalY === undefined
      ? startY + 15
      : doc.previousAutoTable.finalY;

  let isFirstField = true;
  fields.map((field) => {
    let fieldName = field[`fieldName`];
    let itemsByField = allItems.filter((t) => {
      return t.fieldName === fieldName;
    });

    //sort by variety
    itemsByField.sort(CommonUtilities.getSortOrder("variety"));

    doc.setFontSize(10);
    if (!isFirstField) {
      startY += 25;
    }
    doc.text(`Field: ${fieldName}`, 2, startY, {
      align: "left",
    });
    startY += 5;

    //unique varieties
    const varietiesByField = lodash(itemsByField)
      .filter("variety")
      .groupBy((x) => {
        return [x["variety"]];
      })
      .map((children, variety) => {
        const items = children.map((x) => x);
        return {
          variety,
          items,
        };
      })
      .value();
    let showHeaderColumn = true;
    varietiesByField.map((v) => {
      const itemsByVariety = v.items.filter((k) => {
        return k.variety === v.variety;
      });
      printTableByField(
        doc,
        showHeaderColumn,
        data,
        itemsByVariety,
        startY,
        columns,
        tableFontSize,
        numberColumnStyle,
        smallColumnStyle,
        bigColumnStyle
      );
      isFirstField = false;
      //Add data for table total by variety
      if (itemsByVariety && itemsByVariety.length > 0) {
        //Print total by variety
        let textTotalByVariety = `Totals for ${v.variety.toUpperCase()} (${
          itemsByVariety.length
        } ${itemsByVariety.length > 1 ? `deliveries` : `delivery`})`;
        composeTableTotal(
          doc,
          data,
          itemsByVariety,
          textTotalByVariety,
          columnsTotal,
          tableFontSize,
          numberColumnStyle,
          smallColumnStyle,
          bigColumnStyle
        );
      }

      showHeaderColumn = false;
      startY = doc.previousAutoTable.finalY;
    });

    //Print total by field
    let textTotalByField = `Totals for ${fieldName.toUpperCase()} (${
      itemsByField.length
    } ${itemsByField.length > 1 ? `deliveries` : `delivery`})`;

    composeTableTotal(
      doc,
      data,
      itemsByField,
      textTotalByField,
      columnsTotal,
      tableFontSize,
      numberColumnStyle,
      smallColumnStyle,
      bigColumnStyle
    );
  });
  printSummary(doc, data, tableFontSize);
}

function printSummary(doc, data, tableFontSize) {
  doc.addPage();
  let startY = 10;
  doc.line(2, startY, doc.internal.pageSize.width - 4, startY);
  startY += 20;
  doc.setFontSize(12);
  doc.text(`Statement Summary `, 30, startY, {
    align: "left",
  });

  startY += 5;
  const columns4Payment = [];
  const columns4TaxnFee = [{ header: "Name", dataKey: "name" }];
  const columns = [
    { header: "Delivery Weight", dataKey: "netWeight" },
    { header: "Edible Weight", dataKey: "edibleWeight" },
    // { header: "Quality Adj.", dataKey: "qualityAdj" },
  ];
  let netWeight = lodash.sumBy(data.items, `netWeightOrigin`);
  let edibleWeight = lodash.sumBy(data.items, `payableWeightOrigin`);
  // let qualityAdj = lodash.sumBy(data.items, `qualityAdjOrigin`);
  let total = 0;

  for (let i = 0; i < data.summary.payments.length; i++) {
    const payment = data.summary.payments[i];
    let columnTitle = ``;
    if (payment.paymentNo === 1) {
      columnTitle = `1st`;
    } else if (payment.paymentNo === 2) {
      columnTitle = `2nd`;
    } else if (payment.paymentNo === 3) {
      columnTitle = `3rd`;
    } else {
      columnTitle = `${payment.paymentNo}th`;
    }
    columns.push({
      header: `${columnTitle}\nQuality Adj.`,
      dataKey: `qualityAdj${payment.paymentNo}`,
    });
    columns.push({
      header: `${columnTitle} Payment\n(${data.summary.payments[i].date})`,
      dataKey: `payment${payment.paymentNo}`,
    });
    columns4Payment.push({
      header: `${columnTitle} Payment\n(${data.summary.payments[i].date})`,
      dataKey: `payment${payment.paymentNo}`,
    });
    columns4TaxnFee.push({
      dataKey: `payment${payment.paymentNo}`,
    });
    total += payment.amountOrigin;
  }
  columns.push({ header: "Total", dataKey: "total" });
  const dataSummary = [];
  const columnStyles = [];
  const columnStyles4TaxnFee = [];
  const columnStyles4Payments = [];
  const dataSummary4Payments = [];
  const dataSummary4Balance = [];
  const dataSummary4TaxnFee = [];

  columnStyles4TaxnFee.push({
    halign: "left",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 140,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  // columnStyles.push({
  //   halign: "right",
  //   fontSize: tableFontSize,
  //   lineColor: "gray",
  //   lineWidth: 0.1,
  //   cellWidth: 70,
  // });
  total =
    total == null || total === undefined || isNaN(total)
      ? 0
      : parseFloat(total);
  const objectSummary4Payment = {};
  const objectSummary4Balance = {};
  const objectSummary = {
    netWeight: `${CommonUtilities.numberWithCommas(
      (netWeight == null || netWeight === undefined || isNaN(netWeight)
        ? 0
        : parseFloat(netWeight)
      ).toFixed(0)
    )}`,
    edibleWeight: `${CommonUtilities.numberWithCommas(
      (edibleWeight == null || edibleWeight === undefined || isNaN(edibleWeight)
        ? 0
        : parseFloat(edibleWeight)
      ).toFixed(0)
    )}`,
    // qualityAdj: `$${CommonUtilities.numberWithCommasNegative(
    //   (qualityAdj == null || qualityAdj === undefined || isNaN(qualityAdj)
    //     ? 0
    //     : parseFloat(qualityAdj)
    //   ).toFixed(2)
    // )}`,
    total:
      total < 0
        ? `($${CommonUtilities.numberWithCommas(Math.abs(total).toFixed(2))})`
        : `$${CommonUtilities.numberWithCommas(total.toFixed(2))}`,
  };
  var convertedJSON = JSON.parse(JSON.stringify(objectSummary));
  var convertedJSON4Payment = JSON.parse(JSON.stringify(objectSummary4Payment));
  var convertedJSON4Balance = JSON.parse(JSON.stringify(objectSummary4Balance));

  let taxnFeeNames = [];
  for (let i = 0; i < data.summary.payments.length; i++) {
    const payment = data.summary.payments[i];
    if (payment && payment.itemsTaxFee && payment.itemsTaxFee.length > 0) {
      taxnFeeNames = taxnFeeNames.concat(
        payment.itemsTaxFee.map((x) => x.name)
      );
    }
  }
  taxnFeeNames = lodash.uniqBy(taxnFeeNames);
  if (taxnFeeNames && taxnFeeNames.length > 0) {
    taxnFeeNames.map((taxName) => {
      let objTaxnFee = JSON.parse(JSON.stringify({ name: taxName }));
      for (let i = 0; i < data.summary.payments.length; i++) {
        let taxnFeePayment = `$0.00`;
        const payment = data.summary.payments[i];
        if (payment && payment.itemsTaxFee && payment.itemsTaxFee.length > 0) {
          payment.itemsTaxFee.map((t) => {
            if (t.name === taxName) {
              const paymentValue = parseFloat(
                t.payment
                  .replace(`(`, ``)
                  .replace(`)`, ``)
                  .replace(`$`, ``)
                  .replace(`,`, ``)
              );
              //Always display in negative
              taxnFeePayment = `($${CommonUtilities.numberWithCommasNegative(
                paymentValue
              )})`;
            }
          });
        }
        objTaxnFee[`payment${payment.paymentNo}`] = taxnFeePayment;
      }
      dataSummary4TaxnFee.push(objTaxnFee);
    });
  }

  for (let i = 0; i < data.summary.payments.length; i++) {
    const payment = data.summary.payments[i];
    let amount = `$${CommonUtilities.numberWithCommas(
      (payment.amountOrigin == null ||
      payment.amountOrigin === undefined ||
      isNaN(payment.amountOrigin)
        ? 0
        : parseFloat(payment.amountOrigin)
      ).toFixed(2)
    )}`;
    convertedJSON[`payment${payment.paymentNo}`] = amount;
    convertedJSON4Payment[`payment${payment.paymentNo}`] = payment.netPayment;
    const qualityAdjTotal = lodash.sumBy(
      data.items,
      `qualityAdj${payment.paymentNo}Origin`
    );
    const qualityAdj =
      qualityAdjTotal == null ||
      qualityAdjTotal === undefined ||
      isNaN(qualityAdjTotal)
        ? 0
        : parseFloat(qualityAdjTotal);
    convertedJSON[`qualityAdj${payment.paymentNo}`] =
      qualityAdj < 0
        ? `($${CommonUtilities.numberWithCommas(
            Math.abs(qualityAdj).toFixed(2)
          )})`
        : `$${CommonUtilities.numberWithCommas(qualityAdj.toFixed(2))}`;

    //Balance - always display zero
    const balance = 0;
    convertedJSON4Balance[
      `payment${payment.paymentNo}`
    ] = `$${CommonUtilities.numberWithCommas(balance.toFixed(2))}`;

    //Add column style - for column Quality Adj.
    columnStyles.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 70,
    });
    //Add column style - for column Payment
    columnStyles.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 70,
    });
    columnStyles4TaxnFee.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 140,
    });

    //Add column style
    columnStyles4Payments.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 140,
    });
  }
  //Add column style for column Total
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  dataSummary.push(convertedJSON);
  dataSummary4Payments.push(convertedJSON4Payment);
  dataSummary4Balance.push(convertedJSON4Balance);

  doc.autoTable({
    theme: `plain`,
    margin: { left: 80 },
    startY: startY,
    columns: columns,
    body: dataSummary,
    headStyles: {
      halign: "center",
      fontSize: tableFontSize,
      lineWidth: 0.1,
    },
    showHead: `everyPage`,
    columnStyles: columnStyles,
  });

  //print row taxes and fees
  if (dataSummary4TaxnFee && dataSummary4TaxnFee.length > 0) {
    startY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(9);

    doc.autoTable({
      theme: `plain`,
      margin: { left: 80 },
      startY: startY,
      columns: columns4TaxnFee,
      body: dataSummary4TaxnFee,
      headStyles: {
        halign: "center",
        fontSize: tableFontSize,
        lineWidth: 0.1,
      },
      showHead: `never`,
      columnStyles: columnStyles4TaxnFee,
    });
  }
  //print row payments
  if (data.summary.payments && data.summary.payments.length > 0) {
    startY = doc.previousAutoTable.finalY + 10;
    doc.setFontSize(9);
    doc.text(`Payments*:`, 215, startY + 5, {
      align: "right",
    });

    doc.autoTable({
      theme: `plain`,
      margin: { left: 220 },
      startY: startY,
      columns: columns4Payment,
      body: dataSummary4Payments,
      headStyles: {
        halign: "center",
        fontSize: tableFontSize,
        lineWidth: 0.1,
      },
      showHead: `never`,
      columnStyles: columnStyles4Payments,
    });
  }
  //print row balance
  startY =
    doc.previousAutoTable.finalY === undefined
      ? startY + 10
      : doc.previousAutoTable.finalY;

  doc.setFontSize(9);
  doc.text(`Balance:`, 215, startY + 5, {
    align: "right",
  });

  doc.autoTable({
    theme: `plain`,
    margin: { left: 220 },
    startY: startY,
    columns: columns4Payment,
    body: dataSummary4Balance,
    headStyles: {
      halign: "center",
      fontSize: tableFontSize,
      lineWidth: 0.1,
    },
    showHead: `never`,
    columnStyles: columnStyles4Payments,
  });

  // printTablePaymentDetail(doc, data, tableFontSize);

  printOwners(doc, data, tableFontSize, startY);
}

function printOwners(doc, data, tableFontSize, startY) {
  startY += 25;
  const columns = [
    { header: "Payee", dataKey: "name" },
    { header: "Split %", dataKey: "ownerShip" },
  ];
  const columnStyles = [];

  columnStyles.push({
    halign: "left",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 140,
  });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });

  let maxItemsOwner = [];

  for (let i = 0; i < data.summary.payments.length; i++) {
    const payment = data.summary.payments[i];
    const itemsOwner = data.summary.payments[i].itemsOwner;
    let columnTitle = ``;
    if (payment.paymentNo === 1) {
      columnTitle = `1st`;
    } else if (payment.paymentNo === 2) {
      columnTitle = `2nd`;
    } else if (payment.paymentNo === 3) {
      columnTitle = `3rd`;
    } else {
      columnTitle = `${payment.paymentNo}th`;
    }
    columns.push({
      header: `${columnTitle} Payment`,
      dataKey: `payment${payment.paymentNo}`,
    });
    columnStyles.push({
      halign: "right",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
      cellWidth: 70,
    });
    if (
      itemsOwner &&
      itemsOwner.length > 0 &&
      itemsOwner.length > maxItemsOwner.length
    ) {
      maxItemsOwner = itemsOwner;
    }
  }
  columns.push({ header: "Total", dataKey: "total" });
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 70,
  });
  //Compose data
  let arrDataOwner = [];
  const paymentLength = data.summary.payments.length;
  if (maxItemsOwner && maxItemsOwner.length > 0) {
    maxItemsOwner.map((o) => {
      let objData = {
        name: o.name,
        ownerShip: 0,
      };

      let convertedJSON = JSON.parse(JSON.stringify(objData));
      for (let i = 0; i < paymentLength; i++) {
        const payment = data.summary.payments[i];
        convertedJSON[`payment${payment.paymentNo}`] = 0;
      }
      convertedJSON[`total`] = 0;
      arrDataOwner.push(convertedJSON);
    });
  }
  if (arrDataOwner.length > 0) {
    arrDataOwner.map((o) => {
      let total = 0;
      for (let i = 0; i < paymentLength; i++) {
        const itemsOwner = data.summary.payments[i].itemsOwner;
        if (itemsOwner && itemsOwner.length > 0) {
          const owner = itemsOwner.find((x) => {
            return x.name === o.name;
          });
          if (owner) {
            const paymentValue =
              parseFloat(
                owner.payment
                  .replace(`(`, ``)
                  .replace(`)`, ``)
                  .replace(`$`, ``)
                  .replace(`,`, ``)
              ) * (owner.payment.indexOf(`(`) !== -1 ? -1 : 1);
            o.ownerShip = owner.ownerShip;
            o[`payment${i + 1}`] =
              paymentValue < 0
                ? `($${CommonUtilities.numberWithCommas(
                    Math.abs(paymentValue).toFixed(2)
                  )})`
                : `$${CommonUtilities.numberWithCommas(
                    paymentValue.toFixed(2)
                  )}`;
            total += paymentValue;
          }
        }
      }
      o.total =
        total < 0
          ? `($${CommonUtilities.numberWithCommas(Math.abs(total).toFixed(2))})`
          : `$${CommonUtilities.numberWithCommas(total.toFixed(2))}`;
    });
  }
  if (arrDataOwner && arrDataOwner.length > 0) {
    doc.autoTable({
      theme: `plain`,
      margin: { left: 80 },
      startY: startY,
      columns: columns,
      body: arrDataOwner,
      headStyles: {
        halign: "center",
        fontSize: tableFontSize,
        lineWidth: 0.1,
      },
      showHead: `everyPage`,
      columnStyles: columnStyles,
    });
  }
}

function printTablePaymentDetail(doc, data, tableFontSize) {
  let startY = doc.previousAutoTable.finalY + 20;
  doc.setFontSize(9);
  doc.text(`* Payment Detail `, 70, startY, {
    align: "left",
  });
  startY += 5;
  const columns = [
    {
      header: "Date",
      dataKey: "date",
    },
    { header: "Description", dataKey: "description" },
    { header: "Amount", dataKey: "netPayment" },
  ];
  doc.autoTable({
    theme: `plain`,
    margin: { left: 80 },
    startY: startY,
    columns: columns,
    body: data.summary.payments,
    headStyles: {
      halign: "center",
      fontSize: tableFontSize,
      lineWidth: 0.1,
      // cellWidth: 35,
    },
    showHead: `everyPage`,
    columnStyles: {
      0: {
        halign: "center",
        fontSize: tableFontSize,
        lineColor: "gray",
        lineWidth: 0.1,
        cellWidth: 50,
      },
      1: {
        halign: "left",
        fontSize: tableFontSize,
        lineColor: "gray",
        lineWidth: 0.1,
        cellWidth: 150,
      },
      2: {
        halign: "right",
        fontSize: tableFontSize,
        lineColor: "gray",
        lineWidth: 0.1,
        cellWidth: 70,
      },
    },
  });
}

function composeTableTotal(
  doc,
  data,
  items,
  textTotal,
  columnsTotal,
  tableFontSize,
  numberColumnStyle,
  smallColumnStyle,
  bigColumnStyle
) {
  if (items && items.length > 0) {
    //Add data for table total by variety empty
    const payableWeight = lodash.sumBy(items, "payableWeightOrigin");
    const qualityAdj = lodash.sumBy(items, "qualityAdjOrigin");
    const total = lodash.sumBy(items, "totalOrigin");
    const itemsTotal = [];
    const obj = {
      lotNumber: textTotal,
      payableWeight: CommonUtilities.numberWithCommas(
        (payableWeight == null ||
        payableWeight === undefined ||
        isNaN(payableWeight)
          ? 0
          : parseFloat(payableWeight)
        ).toFixed(0)
      ),
      qualityAdj:
        qualityAdj < 0
          ? `($${CommonUtilities.numberWithCommas(
              Math.abs(qualityAdj).toFixed(2)
            )})`
          : `$${CommonUtilities.numberWithCommas(qualityAdj.toFixed(2))}`,
      total:
        total < 0
          ? `($${CommonUtilities.numberWithCommas(Math.abs(total).toFixed(2))})`
          : `$${CommonUtilities.numberWithCommas(total.toFixed(2))}`,
    };
    var convertedJSON = JSON.parse(JSON.stringify(obj));
    for (let i = 0; i < data.summary.payments.length; i++) {
      const payment = data.summary.payments[i];
      let totalPayment = lodash.sumBy(
        items,
        `payment${payment.paymentNo}Origin`
      );
      totalPayment =
        totalPayment == null ||
        totalPayment === undefined ||
        isNaN(totalPayment)
          ? 0
          : parseFloat(totalPayment);
      convertedJSON[`payment${payment.paymentNo}`] =
        totalPayment < 0
          ? `($${CommonUtilities.numberWithCommas(
              Math.abs(totalPayment).toFixed(2)
            )})`
          : `$${CommonUtilities.numberWithCommas(totalPayment.toFixed(2))}`;
    }
    itemsTotal.push(convertedJSON);
    const startY = doc.previousAutoTable.finalY;
    printTableTotal(
      doc,
      data,
      itemsTotal,
      startY,
      columnsTotal,
      tableFontSize,
      numberColumnStyle,
      smallColumnStyle,
      bigColumnStyle
    );
  }
}

function printTableByField(
  doc,
  showHeaderColumn,
  data,
  items,
  startY,
  columns,
  tableFontSize,
  numberColumnStyle,
  smallColumnStyle,
  bigColumnStyle
) {
  let columnStyles = [];
  columnStyles.push({
    halign: "left",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 35,
  });
  columnStyles.push({
    halign: "left",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 35,
  });
  columnStyles.push({
    halign: "center",
    fontSize: tableFontSize,
    lineColor: "gray",
    lineWidth: 0.1,
    cellWidth: 37,
  });

  const smallColumnStyleNew = { ...smallColumnStyle };
  const bigColumnStyleNew = { ...bigColumnStyle };
  const numberColumnStyleNew = { ...numberColumnStyle };
  if (data.summary.payments.length <= 2) {
    smallColumnStyleNew.cellWidth = smallColumnStyleNew.cellWidth + 10;
    bigColumnStyleNew.cellWidth = bigColumnStyleNew.cellWidth + 10;
    numberColumnStyleNew.cellWidth = numberColumnStyleNew.cellWidth + 10;
  }

  columnStyles.push(numberColumnStyle);
  columnStyles.push(smallColumnStyle);
  columnStyles.push(numberColumnStyle);
  columnStyles.push(smallColumnStyle);
  columnStyles.push(smallColumnStyle);
  columnStyles.push(smallColumnStyle);
  columnStyles.push(smallColumnStyle);

  //Column Quality Adj
  // columnStyles.push(numberColumnStyleNew);
  for (let i = 0; i < data.summary.payments.length; i++) {
    columnStyles.push(smallColumnStyle);
    columnStyles.push(bigColumnStyleNew);
  }
  columnStyles.push(smallColumnStyle);
  columnStyles.push(smallColumnStyle);
  columnStyles.push(bigColumnStyleNew);

  doc.autoTable({
    // theme: `plain`,
    margin: { left: 2, right: 2 },
    // margin: { left: margin, right: margin },
    startY: startY,
    // tableLineWidth: 0.1,
    // tableLineColor: "red",
    // head: columns,
    columns: columns,
    body: items,
    headStyles: {
      // fillColor: [33, 150, 243],
      halign: "center",
      fontSize: tableFontSize,
      lineColor: "gray",
      lineWidth: 0.1,
    },
    showHead: showHeaderColumn ? "everyPage" : `never`,
    columnStyles: columnStyles,
    // drawHeaderCell: function (cell, data) {
    //   if (cell.raw === "$/ mt lb") {
    //     //paint.Name header red
    //     cell.styles.fontSize = 15;
    //     cell.styles.textColor = [255, 0, 0];
    //   } else {
    //     cell.styles.textColor = 255;
    //     cell.styles.fontSize = 10;
    //   }
    // },
    // createdCell: function (cell, data) {
    //   // if (cell.raw === "$/ mt lb") {
    //   // cell.styles.fontSize = 15;
    //   cell.styles.textColor = [255, 0, 0];
    //   // }
    // },
    didParseCell: function (table) {
      if (
        table.section === "head" &&
        (table.column.dataKey.indexOf(`mtlb`) !== -1 ||
          table.column.dataKey.indexOf(`payment`) !== -1)
      ) {
        table.cell.styles.fillColor = "#063970";
      }
    },
  });
}

function printTableTotal(
  doc,
  data,
  items,
  startY,
  columns,
  tableFontSize,
  numberColumnStyle,
  smallColumnStyle,
  bigColumnStyle
) {
  const numberColumnStyleNew = { ...numberColumnStyle };
  numberColumnStyleNew.lineWidth = 0;
  const smallColumnStyleNew = { ...smallColumnStyle };
  smallColumnStyleNew.lineWidth = 0;
  const bigColumnStyleNew = { ...bigColumnStyle };
  bigColumnStyleNew.lineWidth = 0;

  let columnStyles = [];
  columnStyles.push({
    halign: "right",
    fontSize: tableFontSize,
    cellWidth: 182,
  });

  const smallColumnStyleNew1 = { ...smallColumnStyleNew };
  const bigColumnStyleNew1 = { ...bigColumnStyleNew };
  const numberColumnStyleNew1 = { ...numberColumnStyleNew };

  if (data.summary.payments.length <= 2) {
    smallColumnStyleNew1.cellWidth = smallColumnStyleNew1.cellWidth + 10;
    bigColumnStyleNew1.cellWidth = bigColumnStyleNew1.cellWidth + 10;
    numberColumnStyleNew1.cellWidth = numberColumnStyleNew1.cellWidth + 10;
  }

  columnStyles.push(numberColumnStyleNew);
  columnStyles.push(smallColumnStyleNew);
  columnStyles.push(smallColumnStyleNew);
  columnStyles.push(smallColumnStyleNew);
  columnStyles.push(smallColumnStyleNew);

  //Column Quality Adj
  // columnStyles.push(numberColumnStyleNew1);
  for (let i = 0; i < data.summary.payments.length; i++) {
    columnStyles.push(smallColumnStyleNew);
    columnStyles.push(bigColumnStyleNew1);
  }
  columnStyles.push(smallColumnStyleNew);
  columnStyles.push(smallColumnStyleNew);
  columnStyles.push(bigColumnStyleNew1);

  doc.autoTable({
    theme: `plain`,
    margin: { left: 2, right: 2 },
    startY: startY,
    columns: columns,
    body: items,
    headStyles: {
      halign: "center",
      fontSize: tableFontSize,
      lineWidth: 0,
      // cellWidth: 35,
    },
    showHead: `never`,
    columnStyles: columnStyles,
  });
}
